import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ADKDetailsViewModel } from '../../../../../models/adk-details-view.model';
import { Subject } from 'rxjs';
import { ManageService } from '../../../../../services/manage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../../../services';
import { ApiResponse } from '../../../../../models/api-response.model';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { DOCUMENT } from '@angular/common';
import { PostcodeList, SuburbList } from '../../../../../models/account-delivery-address';
import { CheckOutService } from '../../../../../services/checkout.service';
import { StateModel } from '../../../../../models/account-ledger.model';
import { ShoppingCartService } from '../../../../../services/shopping-cart.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-edit-kasp-end-user',
  templateUrl: './edit-kasp-end-user.component.html',
  styleUrls: ['./edit-kasp-end-user.component.css']
})
export class EditKaspEndUserComponent implements OnInit, OnDestroy {
  userFormGroup: FormGroup;
  tenantId: string;
  details: ADKDetailsViewModel;
  setFullWindow: boolean = true;
  title: string = "Edit Kasp Tenant Details";
  loadContent: boolean = false;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  filteredPostCode: PostcodeList[];
  filteredSub: PostcodeList[];
  stateList: string[];
  validationArray: any[] = [
    { field: "out_company_name", class: "editTenantNameValidate", message: "Please enter tenant name" },
    { field: "out_tenant_desc", class: "editTenantDescriptionValidate", message: "Please enter tenant description" },
    { field: "out_first_name", class: "editTenantFirstNameValidate", message: "Please enter first name" },
    { field: "out_last_name", class: "editTenantLastNameValidate", message: "Please enter last name" },
    { field: "out_email", class: "editTenantEmailValidate", message: "Please enter tenant email" },
    { field: "out_address_1", class: "editTenantAddressLine1Validate", message: "Please enter address" },
    { field: "out_city", class: "editTenantCityValidate", message: "Please enter suburb" },
    { field: "out_region", class: "editTenantStateValidate", message: "Please enter state" },
    { field: "out_post_code", class: "editTenantPostCodeValidate", message: "Please enter postcode" },
    { field: "out_phone", class: "editTenantPhoneNumberValidate", message: "Please enter phone number" }
  ];

  @ViewChild('myAutocompleteTriggerSub') private _myAutocompleteTriggerSub: MatAutocompleteTrigger;
  @ViewChild('myAutocompleteTriggerPostcode') private _myAutocompleteTriggerPostcode: MatAutocompleteTrigger;

  constructor(
    private manageService: ManageService,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private router: Router,
    private checkOutService: CheckOutService,
    private shoppingCartService: ShoppingCartService,
    private formBuilder: FormBuilder,
    @Inject(DOCUMENT) private _document: Document) {
    this.userFormGroup = this.formBuilder.group({
      out_tenant_id: new FormControl({ value: "", disabled: true }),
      out_company_name: new FormControl({ value: "" }, Validators.required),
      out_tenant_desc: new FormControl("", Validators.required),
      out_first_name: new FormControl("", Validators.required),
      out_last_name: new FormControl("", Validators.required),
      out_email: new FormControl("", this.commonService.emailValidatorRegex()),
      out_address_1: new FormControl("", Validators.required),
      out_address_2: new FormControl(""),
      out_address_3: new FormControl(""),
      out_city: new FormControl("", Validators.required),
      out_region: new FormControl("", Validators.required),
      out_post_code: new FormControl("", [Validators.required, Validators.maxLength(4)]),
      out_phone: new FormControl("", Validators.required),
      out_customer_id: new FormControl(""),
      out_country: new FormControl(""),
      out_culture: new FormControl(""),
      out_digital_wallet_id: new FormControl("")
    });
  }

  ngOnInit() {
    this.loadContent = false;
    this.activatedRoute.parent.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(url => {
      $('#levelOne').animate({ scrollLeft: $('#managekasp').width() + 505 }, 400);
      this.tenantId = url[1].path;
      this.userFormGroup.get("out_email").valueChanges.pipe(
        distinctUntilChanged()
      ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
        this.userFormGroup.get('out_email').setValue(value.trim());
      });
      this.manageService.currentKaspDetailsWatch.subscribe((response: ADKDetailsViewModel) => {
        this.details = response;
        if (this.details) {
          this.userFormGroup.get("out_tenant_id").setValue(this.tenantId);
          this.userFormGroup.get("out_company_name").setValue(this.details.customer.out_company_name);
          this.userFormGroup.get("out_tenant_desc").setValue(this.details.customer.out_tenant_desc);
          this.userFormGroup.get("out_first_name").setValue(this.details.customer.out_first_name);
          this.userFormGroup.get("out_last_name").setValue(this.details.customer.out_last_name);
          this.userFormGroup.get("out_email").setValue(this.details.customer.out_email);
          this.userFormGroup.get("out_address_1").setValue(this.details.customer.out_address_1);
          this.userFormGroup.get("out_address_2").setValue(this.details.customer.out_address_2);
          this.userFormGroup.get("out_address_3").setValue(this.details.customer.out_address_3);
          this.userFormGroup.get("out_city").setValue(this.details.customer.out_city);
          this.userFormGroup.get("out_region").setValue(this.details.customer.out_region);
          this.userFormGroup.get("out_post_code").setValue(this.details.customer.out_post_code);
          this.userFormGroup.get("out_phone").setValue(this.details.customer.out_phone);
          this.userFormGroup.get("out_customer_id").setValue(this.details.customer.out_customer_id);
          this.userFormGroup.get("out_country").setValue(this.details.customer.out_country);
          this.userFormGroup.get("out_culture").setValue(this.details.customer.out_culture);
          this.userFormGroup.get("out_digital_wallet_id").setValue(this.details.customer.out_digital_wallet_id);

        }
        this.loadContent = true;
        //this.loadContent = true;
        //this.router.navigateByUrl("/manageSubscriptions/KASP/KASPDetails/" + this.tenantId);

      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        });
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });

    this.shoppingCartService.getState().subscribe((res: StateModel) => {
      this.stateList = res.states;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  updateEndUser(): void {
    if (this.userFormGroup.valid) {
      let flag = false;
      if (this.userFormGroup.get("out_post_code").value.length < 4) {
        flag = true;
        this.commonService.showValidator('.editTenantPostCodeValidate', "Please input valid postcode", "right", "error");
      }
      if (!flag) {
        this.loadContent = false;
        this.manageService.UpdateGenericTenantInfo(this.userFormGroup.getRawValue()).subscribe((res: ApiResponse) => {
          if (res && res.status) {
            // this.commonService.showSuccess(".saveuser", res.responseMessage,"right");
            this.commonService.implementToast("Tenant info updated successfully", "Success");
            this.manageService.getADKDetails(this.tenantId, "KASP")
              .subscribe((value: ADKDetailsViewModel) => {
                this.details = value;
                this.manageService.monitorKaspDetailsChange(this.details);
                this.manageService.monitorKASPTenantDetails(this.details.customer);
                this.loadContent = true;
              },
                (error: any) => {
                  console.info(error);
                  this.loadContent = true;
                });
          } else {
            this.loadContent = true;
            // this.commonService.showError(".saveuser", res.responseMessage,"right");
            this.commonService.implementToast(res.responseMessage, "Error");
          }
        },
          (error: any) => {
            console.info(error);
            this.loadContent = true;
          });
      }
    } else {
      this.validationArray.forEach(item => {
        this.validateFields(item);
      });
    }

  }

  validateFields(item: any) {
    if (item.field === "out_email") {
      if (this.userFormGroup.get(item.field).hasError("required")) {
        this.commonService.showValidator("." + item.class, item.message, "right", "error");
      } else if (this.userFormGroup.get(item.field).hasError("email")) {
        this.commonService.showValidator("." + item.class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(item.field).valid) {
        this.commonService.showValidator("." + item.class, item.message, "right", "error");
      }
    }
  }

  chooseAutoComplete(option: PostcodeList): void {
    this.userFormGroup.get('out_post_code').setValue(option.postcode);
    this.userFormGroup.get('out_region').setValue(option.state);
    this.userFormGroup.get("out_city").setValue(option.suburb);
  }

  chooseAutoCompletPostcode(event: any): void {
    if (this.filteredPostCode) {
      this.userFormGroup.get('out_post_code').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('out_region').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('out_city').setValue(this.filteredPostCode.filter(option => option.state && option.postcode.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  chooseAutoCompletSuburb(event: any): void {
    if (this.filteredSub) {
      this.userFormGroup.get('out_post_code').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].postcode);
      this.userFormGroup.get('out_region').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].state);
      this.userFormGroup.get('out_city').setValue(this.filteredSub.filter(option => option.state && option.suburb.toLowerCase().startsWith(event.target.value.toLowerCase()))[0].suburb);
    }
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  // startFilterSub(): void {
  //   if (this.userFormGroup.get('out_city').value.length > 2) {
  //     this.checkOutService.getSuburbList(this.userFormGroup.get('out_city').value).subscribe((res: SuburbList[]) => {
  //       this.filteredSub = res;
  //     },
  //       (error: any) => {
  //         console.error(error);
  //         this.loadContent = true;
  //       });
  //   }
  // }

  // startFilterPostcode(): void {
  //   if (this.userFormGroup.get('out_post_code').value.length > 1) {
  //     this.checkOutService.getPostCodeList(this.userFormGroup.get('out_post_code').value).subscribe((res: SuburbList[]) => {
  //       this.filteredPostCode = res;
  //     },
  //       (error: any) => {
  //         console.error(error);
  //         this.loadContent = true;
  //       });
  //   }
  // }

  startFilterPostcode(res: PostcodeList[]): void {
    this.filteredPostCode = res;
  }
  
  startFilterSub(res: PostcodeList[]): void {
    this.filteredSub = res;
  }
  onInputSub(event: KeyboardEvent): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerSub._onChange(target.value);
    }
  }

  onInputPostcode(event: KeyboardEvent): any {
    const target = event.currentTarget as HTMLInputElement;
    if (this._document.activeElement !== target) {
      this._myAutocompleteTriggerPostcode._onChange(target.value);
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent });
    $("#levelOne").animate({ scrollLeft: 250 }, 400);
    //this.router.navigateByUrl("/manageSubscriptions/KASP/KASPDetails/" + this.tenantId);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
